import axios from 'axios';
import eeClient from "elasticemail-webapiclient";
import { firestore } from 'firebase';
import { environment } from "../../config/config";



export const getSettings = async(id) => {
    try {

        const loggedIssuesRef = firestore().collection(environment.issueCollection).doc(environment.settingsCollection);
        return new Promise((resolve, reject) => {
            loggedIssuesRef.get().then(function(doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve();
                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
                resolve();
            });
        });
    
    } catch (e) {
        console.log(e);
        return []
    }
}

export const getIssueTypes = async() => {
    try {
        let result = [];
        const snapshot = await firestore().collection(environment.faqCollection).get();

        snapshot.forEach(docSnapshot => {
            result.push({ ...docSnapshot.data(), id: docSnapshot.id });
        });      

        return result;

    } catch (e) {
        console.log(e);
        return []
    }
}

export const createLoggedIssue = async(issue,settings) => {
    try {

        if(issue) {
            const loggedIssuesRef = firestore().collection(environment.loggedIssuesCollection).doc();
            await loggedIssuesRef.set(issue);
            let data = {
                ...issue,
                issueLink: `${environment.host}${loggedIssuesRef.id}`

            }
            sendElasticEmail(data,settings)
            return loggedIssuesRef.id;
        }

    } catch (e) {
        console.log(e);
        return []
    }
}

export const storeUploadedImage = async(files) => {
    try {
        let allUrls =[];
        let filesUploaded = 0;
        if (Array.isArray(files) && files.length <= 3) {
            return new Promise((resolve, reject) => {
                files.forEach(file => {
                    const url = `${environment.uploadImageUrl}`;
                    const headers = {
                        apiKey: `${environment.uploadImageApiKey}`,
                        'Content-Type': 'multipart/form-data'
                    }
            
                    let formData = new FormData();
                    formData.append('file', file);
            
                    axios.post(url, formData, {
                        headers: headers
                    })
                    .then(function (response) {
                        // handle success
                        let url = response.data && Array.isArray(response.data.url) && response.data.url[0] ? response.data.url[0]: '';
                        allUrls.push(url);
                        filesUploaded++
                        if(filesUploaded === files.length){
                            resolve(allUrls);
                        }
                    })
                    .catch(function (error) {
                        // handle error
                    })
                });
                
            });
        }
    } catch (e) {   
        console.log(e)
        return []
    }
}

export const getSelectedIssue = async(id) => {
    try {

        if(id) {
            const loggedIssuesRef = firestore().collection(environment.loggedIssuesCollection).doc(id);
            return new Promise((resolve, reject) => {
                loggedIssuesRef.get().then(function(doc) {
                    if (doc.exists) {
                        resolve(doc.data())
                    } else {
                        resolve();
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                    resolve();
                });
            });
        }
    
    } catch (e) {
        console.log(e);
        return []
    }
}

export const updateIssue = async(issue,id,settings) => {
    try {
        if(issue && id) {
            const loggedIssuesRef = firestore().collection(environment.loggedIssuesCollection).doc(id);
            if(issue.status === 'Escalated'){
                let data = {
                    ...issue,
                    issueLink: `${environment.host}${loggedIssuesRef.id}`
    
                }
                sendElasticEmail(data,settings)
            }
            loggedIssuesRef.set(issue);
        }

    } catch (e) {
        console.log(e);
        return []
    }
}

 const sendElasticEmail = (data, settings) => {
     
    const options = {
        apiKey: environment.elasticApiKey,
        apiUri: environment.elsaticHost,
        apiVersion: environment.elsaticVersion
    }
    
    let emailParams = {};
    const EE = new eeClient(options);

    if(data && data.hasOwnProperty('status')) {
        if(data.status !== "Escalated") {
            if (settings && settings.hasOwnProperty('createIssueSettings')) {
                emailParams = {
                    "subject": settings.createIssueSettings.userIssueEmailSubject,
                    "to": settings.createIssueSettings.userToEmail,
                    "from": settings.createIssueSettings.userFromEmail,
                    "userReplyToEmail": settings.createIssueSettings.userFromEmail,
                    "template": settings.createIssueSettings.userIssueEmailTemplate,
                    "merge_issueLink": data.issueLink,
                    "merge_mobile": data.mobile,
                    "merge_comment": data.comment,
                    "merge_email": data.email,
                };
            } else {
                emailParams = {
                    "subject": environment.userIssueEmailSubject,
                    "to": environment.userToEmail,
                    "from": environment.userFromEmail,
                    "userReplyToEmail": environment.userToEmail,
                    "template": environment.userIssueEmailTemplate,
                    "merge_issueLink": data.issueLink,
                    "merge_mobile": data.mobile,
                    "merge_comment": data.comment,
                    "merge_email": data.email,
                };
            }
            
            
        } else {
            if (settings && settings.hasOwnProperty('escalateIssueSettings')) {
                emailParams = {
                    "subject": settings.escalateIssueSettings.adminIssueEmailSubject,
                    "to": settings.escalateIssueSettings.adminToEmail,
                    "from": settings.escalateIssueSettings.adminFromEmail,
                    "userReplyToEmail": settings.escalateIssueSettings.adminReplyToEmail,
                    "template": settings.escalateIssueSettings.adminIssueEmailTemplate,
                    "merge_issueLink": data.issueLink,
                    "merge_mobile": data.mobile,
                    "merge_comment": data.comment,
                    "merge_email": data.email,
                    "merge_escalateReason": data.escalateReason,
                };
            } else {
                emailParams = {
                    "subject": environment.adminIssueEmailSubject,
                    "to": environment.adminToEmail,
                    "from": environment.adminFromEmail,
                    "userReplyToEmail": environment.adminReplyToEmail,
                    "template": environment.adminIssueEmailTemplate,
                    "merge_issueLink": data.issueLink,
                    "merge_mobile": data.mobile,
                    "merge_comment": data.comment,
                    "merge_email": data.email,
                    "merge_escalateReason": data.escalateReason,
                };
            }
            console.log(emailParams)
        }
    }
    EE.Email.Send(emailParams)
    .catch((err) => {
        throw new Error(err);
    });
 }

